import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import PageSEO from '@/components/feature/PageSEO';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import { useState, useEffect } from 'react';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const [activeSlug, setActiveSlug] = useState(slug || '');

  useEffect(() => {
    setActiveSlug(slug || '');
  }, [slug]);

  const activeCategory = categories.find((c) => c.slug === activeSlug);
  const filteredArticles = articles.filter((a) => a.categorySlug === activeSlug);

  return (
    <>
      <PageSEO
        title={activeCategory ? activeCategory.name : '分类'}
        description={activeCategory ? activeCategory.description : '黄油推荐分类页面'}
        keywords="黄油推荐,黄油分类,黄油评测"
        canonicalPath={`/category/${activeSlug}`}
      />
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { name: '首页', path: '/' },
            { name: activeCategory?.name || '分类' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-8">
          <div className="max-w-6xl mx-auto">
            <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              {activeCategory?.name}
            </h1>
            <p className="mt-2 text-sm text-foreground-600">{activeCategory?.description}</p>

            <div className="mt-6 flex flex-wrap gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`px-3 py-1.5 text-xs font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                    activeSlug === cat.slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {filteredArticles.length > 0 ? (
                filteredArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
                  >
                    <div className="relative w-full h-44 overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        title={`${article.title} - 黄油推荐`}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-4">
                      <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                        {article.title}
                      </h3>
                      <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                        {article.excerpt}
                      </p>
                      <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                        <span>{article.publishDate}</span>
                        <span>{article.readTime} 分钟阅读</span>
                        <span className="text-primary-500 flex items-center gap-1">
                          <i className="ri-star-fill"></i>
                          {article.rating}
                        </span>
                      </div>
                    </div>
                  </Link>
                ))
              ) : (
                <div className="col-span-full text-center py-16">
                  <p className="text-foreground-500">该分类下暂无文章</p>
                </div>
              )}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}